import React from "react";
import { useTranslation } from "react-i18next";

function Stat({ label, value, dot }) {
    return (
        <span className="inline-flex items-baseline gap-1.5">
            <span
                className={`w-1.5 h-1.5 rounded-full ${dot} translate-y-[-2px]`}
            />
            <span className="tabular-nums font-medium text-gray-900">
                {value}
            </span>
            <span className="text-gray-500">{label}</span>
        </span>
    );
}

export default function ApiSecurityScoreBar({ passed, warned, failed, total }) {
    const { t } = useTranslation();
    const tested = passed + warned + failed;
    const pct = (n) => `${total > 0 ? (n / total) * 100 : 0}%`;

    return (
        <div className="mb-4">
            <div className="flex h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
                <div
                    className="bg-emerald-500 transition-[width] duration-700 ease-out"
                    style={{ width: pct(passed) }}
                />
                <div
                    className="bg-amber-500 transition-[width] duration-700 ease-out"
                    style={{ width: pct(warned) }}
                />
                <div
                    className="bg-red-500 transition-[width] duration-700 ease-out"
                    style={{ width: pct(failed) }}
                />
            </div>
            <dl className="mt-2 flex items-baseline gap-4 text-xs text-gray-600">
                <Stat
                    label={t("appPreview.protected") || "Protected"}
                    value={passed}
                    dot="bg-emerald-500"
                />
                {warned > 0 && (
                    <Stat
                        label={t("appPreview.warningsHeading") || "Review"}
                        value={warned}
                        dot="bg-amber-500"
                    />
                )}
                <Stat
                    label={t("appPreview.unprotected") || "Unprotected"}
                    value={failed}
                    dot="bg-red-500"
                />
                <span className="ml-auto tabular-nums text-gray-400">
                    {tested}/{total}
                </span>
            </dl>
        </div>
    );
}
